/**
 * Сервис магазина
 * @module API/shops
 * */

import client from 'API/client'

const SHOPS_PREFIX = 'shops/'

/**
 * Получить список магазинов
 * @function
 * @param {Object} params - параметры запроса
 * @param {Number} params.page - запрашиваемая страница
 * @param {Number} params.items_on_page - количество записей на странице
 * @param {Object} params.filters - объект фильтров (column_name: value)
 * @param {String} params.group_by - по какому столбцу сгруппировать магазины
 * @return {Promise}
 * */
export const getShops = (params = {}) => client.post(`${SHOPS_PREFIX}shops`, params)
